import { Variants } from 'framer-motion';

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  show: { 
    opacity: 1, 
    y: 0, 
    transition: { 
      duration: 0.6, 
    } 
  }
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  show: { 
    opacity: 1, 
    transition: { 
      duration: 0.6, 
    } 
  }
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.9 },
  show: { 
    opacity: 1, 
    scale: 1, 
    transition: { 
      duration: 0.5, 
    } 
  }
};

export const slideInLeft: Variants = {
  hidden: { opacity: 0, x: -24 },
  show: { 
    opacity: 1, 
    x: 0, 
    transition: { 
      duration: 0.6, 
    } 
  }
};

export const slideInRight: Variants = {
  hidden: { opacity: 0, x: 24 },
  show: { 
    opacity: 1, 
    x: 0, 
    transition: { 
      duration: 0.6, 
    } 
  }
};

export const stagger: Variants = {
  show: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};

export const staggerFast: Variants = {
  show: {
    transition: {
      staggerChildren: 0.04,
      delayChildren: 0.05
    }
  }
};

export const buttonHover: Variants = {
  hover: { 
    scale: 1.02, 
    y: -2,
    transition: { duration: 0.2 }
  },
  tap: { 
    scale: 0.98,
    transition: { duration: 0.1 }
  }
};

export const cardHover: Variants = {
  hover: { 
    y: -4,
    transition: { duration: 0.3 }
  }
};

export const parallax: Variants = {
  hidden: { y: 0, rotate: 0 },
  show: { 
    y: 12, 
    rotate: 6,
    transition: { 
      duration: 0.8, 
    } 
  }
};
